module.exports = __webpack_public_path__ + "static/media/cards.c53c4667.svg";